
import { map, length, ofArray } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { join, printf, toFail } from "../fable_modules/fable-library-js.5.13.0/String.js";

export const VERSION = ofArray(["6", "3", "12"]);

export const VersionString = ((length(VERSION) < 3) ? toFail(printf("Badly formatted version %A (VERSION must be list of 3 or more strings)"))(VERSION) : undefined, "v" + join(".", map((i) => i, VERSION)));

